import React from "react";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";
import type { AiAssistantPanelMode } from "src/components/views/ai/assistant/panel/AiAssistantPanelConstants.ts";

export interface AiAssistantContextValue {
	drawerWidth: string;
	isEnabled: boolean;
	isOpen: boolean;
	openAiAssistant: () => Promise<void>;
	panelMode: AiAssistantPanelMode;
	reservedWidth: string;
	setIsOpen: (isOpen: boolean) => void;
	setPanelMode: (panelMode: AiAssistantPanelMode) => void;
	setWidth: (width: number) => void;
	width: number;
}

export const AiAssistantContext = React.createContext<AiAssistantContextValue | undefined>(undefined);

export const useAiAssistant = () => useContextOrThrow(AiAssistantContext);

export const useOptionalAiAssistant = () => React.useContext(AiAssistantContext);
